import { render, staticRenderFns } from "./_NotifFillProfile.vue?vue&type=template&id=1021cb7f&scoped=true&"
import script from "./_NotifFillProfile.vue?vue&type=script&lang=js&"
export * from "./_NotifFillProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1021cb7f",
  null
  
)

export default component.exports